import React from 'react';
import GoogleMapReact from 'google-map-react';
import Geocode from 'react-geocode';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withCookies } from 'react-cookie';
import { geocodeByAddress } from 'react-places-autocomplete';
import moment from 'moment-timezone';
import { fetchOrganization } from '../../actions/authActions';
import {
  fetchProgram,
  getProgram,
  fetchProgramContacts,
  fetchAuthorizedProgramSettings,
  updateProgramLatLng,
} from '../../actions/programBrochureActions';
import Carousel from '../../components/Admin/ProgramView/Carousel';
import ProgramViewDescription from '../../components/Admin/ProgramView/ProgramViewDescription';
import ProgramViewTestimonial from '../../components/Admin/ProgramView/ProgramViewTestimonial';
import ProgramViewAbout from '../../components/Admin/ProgramView/ProgramViewAbout';
import ProgramAdditionalDocuments from '../../components/Admin/ProgramView/ProgramAdditionalDocuments/ProgramAdditionalDocuments';
import ProgramViewChart from '../../components/Admin/ProgramView/ProgramViewChart/ProgramViewChart';
import ProgramAmmenities from '../../components/Admin/ProgramView/ProgramAmmenities/ProgramAmmenities';
import ProgramScholarship from '../../components/Admin/ProgramView/ProgramScholarship/ProgramScholarship';
import ProgramEligibility from '../../components/Admin/ProgramView/ProgramEligibility/ProgramEligibility';
import AdditionalInfo from '../../components/Admin/ProgramView/AdditionalInfo';
import ProgramOrganization from '../../components/Admin/ProgramView/ProgramOrganization/ProgramOrganization';
import StickyFooter from '../../components/StickyFooter';
import Loader from '../../components/Loader/Loader';
import isoCountries from '../../shared/helpers/country-codes';
import _isEmpty from 'lodash/isEmpty';
import _compact from 'lodash/compact';
import Alert from '../../components/AlertsOverlay/Alert';
import AlertsOverlay from '../../components/AlertsOverlay/AlertsOverlay';
import ContactsModal from '../../components/ContactsModal/ContactsModal';
import customBranding from '../../hoc/customBranding/customBranding';
import ProgramViewInfoBar from '../../components/Admin/ProgramView/ProgramViewInfoBar';
import s from './admin-program-view.css';

@customBranding
class AdminProgramView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lat: null,
      lng: null,
      uploadAttachment: [],
      savedAttachments: [],
      programSupport: [],
      reviewText: '',
      reviewerName: '',
      reviewerDetails: '',
      locations: [],
      defaultLevelValue: 0,
      contactsShow: false,
    };

    this.convertPrice = this.convertPrice.bind(this);
    this.convertCountryCode = this.convertCountryCode.bind(this);
    this.showContactsModal = this.showContactsModal.bind(this);
    this.hideContactsModal = this.hideContactsModal.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.removeNewFile = this.removeNewFile.bind(this);
    this.removeSavedFile = this.removeSavedFile.bind(this);
  }

  componentDidMount() {
    const { cookies } = this.props;
    const token = cookies.get('token');
    let parts = window.location.host.split('.');
    let subdomain = parts[0];

    this.props.fetchAuthorizedProgramSettings(this.props.id, 'client');
    this.props.getProgram(this.props.id, 'client');
    this.props.fetchProgramContacts(this.props.id);
    this.props.fetchOrganization(subdomain);
  }

  componentWillReceiveProps(nextProps) {
    // NYC default - if for some reason the lat/lon are undefined then the page breaks
    // This thing will be catered by calling an action which will send new lat, lng
    if (nextProps.lat && nextProps.lng && false) {
      this.setState({
        lat: nextProps.lat,
        lng: nextProps.lng,
      });
    } else {
      if (!_isEmpty(nextProps.locations)) {
        const city = nextProps.locations[0].city;
        const country = nextProps.locations[0].country;
        const location = city + ', ' + country;
        this.updateLocation(location);
      }
    }
    if (nextProps.programSupport) {
      this.setState({ programSupport: nextProps.programSupport });
    }
    if (nextProps.programReview) {
      const programReview = nextProps.programReview;
      this.setState({
        reviewText: programReview.review_text,
        reviewerName: programReview.reviewer_name,
        reviewerDetails: programReview.reviewer_details,
      });
    }
    if (nextProps.programHash && nextProps.locations[0]) {
      const locations = nextProps.locations.filter(
        location => location.alpha2 != null,
      );
      this.setState({ locations });
    }
    if (nextProps.programSupportIncluded) {
      const defaultLevelValue = nextProps.programSupportIncluded.length;
      this.setState({
        defaultLevelValue,
      });
    }
  }

  updateLocation = location => {
    geocodeByAddress(location)
      .then(res => res[0])
      .then(res => {
        this.setState(
          {
            lat: res.geometry.location.lat(),
            lng: res.geometry.location.lng(),
          },
          () => {
            const data = {
              lat: this.props.coordinates[0][0].data.lat,
              lng: this.props.coordinates[0][0].data.lon,
            };
            this.props.updateProgramLatLng(this.props.id, data);
          },
        );
      })
      .catch(error => {
        console.error('error', error);
      });
  };

  convertPrice(price) {
    const dollars = price / 100;
    return dollars
      .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      .slice(0, -3);
  }

  convertCountryCode = code => isoCountries[code].name;

  // Program Contacts modal
  showContactsModal = () => {
    this.setState({ contactsShow: true });
  };

  hideContactsModal = () => {
    this.setState({ contactsShow: false });
  };

  onFileChange(fileUploaded, file) {
    this.setState({ isFileUploaded: fileUploaded, file: file });
    this.setState(prevState => ({
      uploadAttachment: prevState.uploadAttachment.concat(file),
    }));
  }

  removeNewFile = file => {
    const array = [...this.state.uploadAttachment];
    file._destroy = true;
    array.slice(file, 1);

    this.setState({ uploadAttachment: array });

    this.setState({
      uploadAttachment: this.state.uploadAttachment.filter(
        document => document !== file,
      ),
    });
  };

  removeSavedFile = file => {
    const array = [...this.state.savedAttachments];
    file._destroy = true;
    array.slice(file, 1);

    this.setState({ savedAttachments: array });

    this.setState({
      savedAttachments: this.state.savedAttachments.filter(
        document => document !== file,
      ),
    });
  };

  render() {
    if (
      this.props.loading == true ||
      this.props.programHash === undefined ||
      this.props.authorizedProgramLoading == true
    ) {
      return <Loader />;
    } else if (this.props.program == null) {
      return (
        <div>
          <div>error</div>
        </div>
      );
    }
    const loc = this.state.locations;
    const locations =
      loc.length > 0 && loc[0].alpha2 !== null
        ? loc
            .map(location => {
              if (location.city === '' || location.city === null) {
                return `${location.country}`;
              }
              return `${location.city}, ${location.country}`;
            })
            .join('; ')
        : '';

    const ranges = this.props.programRanges.map(date => {
      if (date.use_exact_dates == true) {
        return `${moment(new Date(date.start_date)).format(
          'MMM D[,] YYYY',
        )} - ${moment(new Date(date.end_date)).format('MMM D[,] YYYY')}`;
      }
      return `${moment(new Date(date.start_date)).format(
        'MMM [] YYYY',
      )} - ${moment(new Date(date.end_date)).format('MMM [] YYYY')}`;
    });
    const subjects = _compact(this.props.programSubjects).map(sub => sub.name);

    // View Section
    if (this.props.status == 'view') {
      const mapLocation = Geocode.fromAddress({ locations }).then(
        response => {
          const { lat, lng } = response.results[0].geometry.location;
          return { lat, lng };
        },
        error => {},
      );
      const alias_program = this.props.customAliases
        ? this.props.customAliases.alias_program
        : 'Program';
      // View Section
      return (
        <div className={`${s.noPadding} container-fluid`}>
          <AlertsOverlay alerts={this.props.alerts}>
            <Alert />
          </AlertsOverlay>
          <Carousel
            role="Admin"
            status="view"
            programStatus={this.props.programStatus}
            authorized={this.props.authorized}
            internal_program={this.props.internal_program}
            background={this.props.programHash.background_photo.url}
            id={this.props.id}
          />
          <ContactsModal
            show={this.state.contactsShow}
            handleClose={this.hideContactsModal}
            contacts={this.props.contacts}
            organizationDescription={this.props.organizationDescription}
            aliasProgram={alias_program}
          />
          <div className="row no-gutters">
            <ProgramViewInfoBar
              programId={this.props.id}
              programProvider={this.props.provider}
              programTitle={this.props.programHash.title}
              userRole={'Admin'}
              programContacts={this.props.contacts}
            />
            <ProgramViewDescription
              provider={this.props.provider}
              role="Admin"
              status="view"
              programTypes={this.props.programTypes}
              title={this.props.programHash.title}
              description={
                this.props.programHighlight.text
                  ? this.props.programHighlight.text
                  : ''
              }
              subdescription={this.props.programLocation.text}
              locations={locations}
              low={
                this.props.programRanges[0]
                  ? this.convertPrice(
                      this.props.programRanges[0].low_cost_cents,
                    )
                  : 0
              }
              high={this.convertPrice(
                this.props.programRanges[0]
                  ? this.props.programRanges[0].high_cost_cents
                  : 0,
              )}
              ranges={ranges}
              subjects={subjects}
              showContacts={this.showContactsModal}
              handleContactsClose={this.hideContactsModal}
              customBranding={this.props.customBranding.themes}
              programId={this.props.id}
              contacts={this.props.contacts}
            />
          </div>
          <div className="row no-gutters">
            <div className="col-sm-8">
              {this.state.reviewText ? (
                <ProgramViewTestimonial
                  role="Admin"
                  status="view"
                  reviewText={this.state.reviewText}
                  name={this.state.reviewerName}
                  details={this.state.reviewerDetails}
                  // status={this.props.status}
                />
              ) : (
                ''
              )}
            </div>
          </div>
          {this.props.programMap == true ? (
            <div className="row no-gutters">
              <div className={s.mapWrapper}>
                {
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: 'AIzaSyDyZnxFjwYKZv_QCVKkOAUpOxDOSMmFOJA',
                    }}
                    center={{
                      lat: Number(this.props.coordinates[0][0].data.lat),
                      lng: Number(this.props.coordinates[0][0].data.lon),
                    }}
                    zoom={12}
                  >
                  </GoogleMapReact>
                }
              </div>
            </div>
          ) : (
            <div />
          )}
          <ProgramViewAbout
            role="Admin"
            status="view"
            immersion={this.props.programHash.language_immersion}
            languages={this.props.programLanguages}
            locations={this.props.locations}
            locationNotes={this.props.locationNotes}
            subjects={this.props.programSubjects}
            courses={this.props.programCourses}
            activites={this.props.programActivities}
            excursions={this.props.programExcursions}
            housing={this.props.programHousing}
            additionals={this.props.programOpportunities}
            alias_program={alias_program}
            pActivities={this.props.pActivities}
            pExcursions={this.props.pExcursions}
            pAddons={this.props.pAddons}
            activityNotes={this.props.activityNotes}
            pCourses={this.props.pCourses}
            hostOrg={this.props.hostOrg}
            hostOrgNotes={this.props.hostOrgNotes}
            housingNotes={this.props.housingNotes}
            academicNotes={this.props.academicNotes}
            programTypes={this.props.programTypes}
          />
          <div className="row no-gutters">
            <div className="col-sm-12">
              <ProgramViewChart
                role="Admin"
                status="view"
                client_account={
                  this.props.programHash.primary_client_account_id
                }
                ranges={this.props.ranges}
                customBranding={this.props.customBranding.themes}
                authorized={this.props.authorized}
                authorizedProgram={this.props.authorizedProgram}
                orgTimeZone={this.props.orgTimeZone}
                provider={this.props.provider}
                internal_program={this.props.internal_program}
                home_campus={this.props.home_campus}
                aliasProgram={alias_program}
              />
            </div>
          </div>
          {this.props.currentFiles.length > 0 ? (
            <ProgramAdditionalDocuments
              role="Admin"
              status="view"
              uploadAttachment={this.state.uploadAttachment}
              onFileChange={this.onFileChange}
              removeNewFile={this.removeNewFile}
              removeSavedFile={this.removeSavedFile}
              id={this.props.id}
              currentFiles={this.props.currentFiles}
            />
          ) : (
            ''
          )}
          <div className="row no-gutters">
            <div className="col-sm-12">
              <ProgramAmmenities
                role="Admin"
                status="view"
                idAmmenities={this.props.programAmenitiesIncludedWithId}
                ammenities={this.props.programDisplayableAmenities}
                included={this.props.programAmenitiesIncluded}
                excluded={this.props.programAmenitiesExcluded}
                aliasProgram={alias_program}
              />
            </div>
          </div>
          <div className="row no-gutters">
            <div className="col-sm-12">
              {this.props.programEligibility.eligibility_info ? (
                <ProgramEligibility
                  role="Admin"
                  status="view"
                  eligibility={this.props.programEligibility.eligibility_info}
                />
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="row no-gutters">
            <div className="col-sm-12">
              {!_isEmpty(this.props.programScholarship) &&
              !_isEmpty(this.props.programScholarship.scholarship_info) ? (
                <ProgramScholarship
                  role="Admin"
                  status="view"
                  financialAid={this.props.programScholarship}
                />
              ) : (
                ``
              )}
            </div>
          </div>
          {this.props.organizationDescription ? (
            <div className="row no-gutters">
              <div className="col-sm-12">
                <ProgramOrganization
                  role="Admin"
                  status="view"
                  contacts={this.props.contacts}
                  organizationDescription={this.props.organizationDescription}
                  provider={this.props.provider}
                />
              </div>
            </div>
          ) : (
            ''
          )}
          <div className="row no-gutters">
            <div className="col-sm-12">
              {this.props.internal_program && (
                <StickyFooter
                  role="Admin"
                  status="view"
                  id={this.props.id}
                  programStatus={this.props.programStatus}
                  alias_program={alias_program}
                />
              )}
            </div>
          </div>
        </div>
      );
    } else if (this.props.status == 'edit') {
      // Edit Section

      return (
        <div className={`${s.noPadding} container-fluid`}>
          <Carousel
            role="Admin"
            status="edit"
            // status={this.props.status}
            authorized={this.props.authorized}
            background={this.props.programHash.background_photo.url}
          />
          <div className="row no-gutters">
            <ProgramViewDescription
              role="Admin"
              status="edit"
              programTypes={this.props.programTypes}
              // status={this.props.status}
              title={this.props.programHash.title}
              description={
                this.props.programHighlight.text
                  ? this.props.programHighlight.text
                  : ''
              }
              subdescription={this.props.programLocation.text}
              locations={locations}
              low={this.convertPrice(
                this.props.programRanges[0].low_cost_cents,
              )}
              high={this.convertPrice(
                this.props.programRanges[0].high_cost_cents,
              )}
              ranges={ranges}
              subjects={subjects}
              programId={this.props.id}
              authorized={this.props.authorized}
              alias_program={alias_program}
            />
          </div>
          <div className="row no-gutters">
            <div className={`col-sm-12 ${s.editTestimonialView}`}>
              <ProgramViewTestimonial
                reviewText={this.props.programReview.review_text}
                name={this.props.programReview.reviewer_name}
                details={this.props.programReview.reviewer_details}
                status={this.props.status}
                customAliases={this.props.customAliases}
              />
            </div>
          </div>
          {this.props.programMap == true ? (
            <div className="row no-gutters">
              <div className={s.mapWrapper}>
                {
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: 'AIzaSyDyZnxFjwYKZv_QCVKkOAUpOxDOSMmFOJA',
                    }}
                    center={{
                      lat: Number(this.props.coordinates[0][0].data.lat),
                      lng: Number(this.props.coordinates[0][0].data.lon),
                    }}
                    zoom={11}
                  />
                }
              </div>
            </div>
          ) : (
            <div />
          )}
          <div className="row no-gutters">
            <div className={`col-sm-12 ${s.editTestimonialView}`}>
              <ProgramViewAbout
                role="Admin"
                status="edit"
                immersion={this.props.programHash.language_immersion}
                languages={this.props.programLanguages}
                locations={this.props.locations}
                subjects={this.props.programSubjects}
                courses={this.props.programCourses}
                activites={this.props.programActivities}
                excursions={this.props.programExcursions}
                support={this.props.programSupport}
                housing={this.props.programHousing}
              />
            </div>
          </div>
          <div className="row no-gutters">
            <div className={`col-sm-12 ${s.editTestimonialView}`}>
              <ProgramAdditionalDocuments role="Admin" status="edit" />
            </div>
          </div>
          <div className="row no-gutters">
            <div className={`col-sm-12 ${s.editTestimonialView}`}>
              <AdditionalInfo
                role="Admin"
                status="edit"
                eligibility={this.props.programEligibility.eligibility_info}
                financialAid={this.props.programScholarship}
              />
            </div>
          </div>
          <div className="row no-gutters">
            <div className="col-sm-12">
              {this.props.internal_program && (
                <StickyFooter role="Admin" status="edit" id={this.props.id} />
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = state => ({
  program: state.program.program,
  authorizedProgram: state.program.authorizedProgram,
  programHash: state.program.programHash.program,
  ranges: state.program.programHash.ranges,
  programRanges: state.program.programHash.program_ranges,
  programHighlight: state.program.programHash.program_highlight,
  programEligibility: state.program.programHash.program_eligibility,
  programDisplayableAmenities:
    state.program.programHash.program_displayable_amenities,
  programAmenitiesIncluded:
    state.program.programHash.program_amenities_included,
  programAmenitiesExcluded:
    state.program.programHash.program_amenities_excluded,
  programAmenitiesIncludedWithId:
    state.program.programHash.program_displayable_amenities_with_id,
  programAmenitiesExcludedWithId:
    state.program.programHash.program_amenities_excluded_with_id,
  programReview: state.program.programHash.program_review,
  programExcursions: state.program.programHash.program_excursions,
  programSubjects: state.program.programHash.program_subjects,
  programTypes: state.program.programHash.program_types,
  programSupport: state.program.programHash.program_support,
  programSupportIncluded: state.program.programHash.program_support_included,
  programLocation: state.program.programHash.program_location,
  programActivities: state.program.programHash.program_activity,
  hostOrg: state.program.programHash.host_organization,
  hostOrgNotes: state.program.programHash.host_organization_notes,
  housingNotes: state.program.programHash.housing_notes,
  academicNotes: state.program.programHash.academic_notes,
  pActivities: state.program.programHash.pactivities,
  pExcursions: state.program.programHash.pexcursions,
  pAddons: state.program.programHash.padd_ons,
  activityNotes: state.program.programHash.activity_notes,
  pCourses: state.program.programHash.pcourses,
  programCourses: state.program.programHash.program_courses,
  programHousing: state.program.programHash.program_housing,
  programScholarship: state.program.programHash.program_scholarship,
  programLanguages: state.program.programHash.program_languages,
  coordinates: state.program.programHash.coordinates,
  programMap: state.program.programHash.program_map,
  locations: state.program.programHash.locations,
  locationNotes: state.program.programHash.location_notes,
  programStatus: state.program.programHash.publish_status,
  authorizedProgramLoading: state.program.authorizedProgramLoading,
  loading: state.program.programLoading,
  programOpportunities: state.program.programHash.program_opportunities,
  alerts: state.alerts,
  contacts: state.program.contacts,
  provider: state.program.programHash.provider,
  organizationDescription: state.program.programHash.organization_description,
  customBranding: state.profile.customBranding || {},
  authorized: state.program.programHash.authorized,
  internal_program: state.program.programHash.internal_program,
  home_campus: state.program.programHash.home_campus,
  customAliases: state.profile.customAliases || {},
  lat: state.program.programHash.lat,
  lng: state.program.programHash.lng,
  currentFiles: state.program.programHash.program_attachments,
  orgTimeZone: state.profile.orgTimezone,
});

export default compose(
  withCookies,
  withStyles(s),
  connect(
    mapStateToProps,
    {
      fetchOrganization,
      fetchProgram,
      getProgram,
      fetchProgramContacts,
      fetchAuthorizedProgramSettings,
      updateProgramLatLng,
    },
  ),
)(AdminProgramView);

var divStyle = {
  marginTop: '150px',
};
